import { InjectionToken } from '@angular/core';

// Optional token to configure an absolute API base URL at the app level.
// If not provided, the interceptor will leave relative '/api' URLs as-is
// so you can use the Angular dev proxy in development.
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
